import React, { Component } from 'react';
import { safeParse } from '../utils';
import TAOS from "./../Taos";

import {
  ArrowIconB 
} from './SVGIcons';

import Social from './Social'
import OffcanvasForm from './OffcanvasForm';

// Обёртка над html-react-parser: не падает на пустом/undefined значении
// (раньше SSR бросал TypeError и вся страница отдавала 503 «Технические работы»)
const Parser = safeParse;

class App extends Component {
  static defaultProps = {
    offset: 1,
    hone: false
  }

  state = {
    showForm: false
  };

  // Метод для открытия формы
  openForm = () => {
    this.setState({ showForm: true });
  };

  // Метод для закрытия формы
  closeForm = () => {
    this.setState({ showForm: false });
  };

  // Обработчик успешной отправки
  handleFormSuccess = (message) => {
    if (this.props.onSuccess) {
      this.props.onSuccess(message);
    }
  };

  // Обработчик ошибки отправки
  handleFormError = (error) => {
    if (this.props.onError) {
      this.props.onError(error);
    }
  };

  render() {
    const {
      offset,
      hone
    } = this.props

    const { showForm } = this.state;

    const data = this.props?.data || {}
    const katalog_ng = data?.katalog_ng || {}

    return (
      <>
        <div className={`overflow-x-hidden ` + ( offset == 1 ? `mt-[70px] xl:mt-[80px]` : `mt-[70px] xl:mt-[150px]` )}>
          <div className='container'>
            <div className='w-full text-center xl:text-start'>
              <div className='inline-flex items-center px-[12px] xl:px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px] text-[14px] xl:text-[16px] '>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15 6.1875V13.5C15 15.75 13.6575 16.5 12 16.5H6C4.3425 16.5 3 15.75 3 13.5V6.1875C3 3.75 4.3425 3.1875 6 3.1875C6 3.6525 6.18748 4.0725 6.49498 4.38C6.80248 4.6875 7.2225 4.875 7.6875 4.875H10.3125C11.2425 4.875 12 4.1175 12 3.1875C13.6575 3.1875 15 3.75 15 6.1875Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12 3.1875C12 4.1175 11.2425 4.875 10.3125 4.875H7.6875C7.2225 4.875 6.80248 4.6875 6.49498 4.38C6.18748 4.0725 6 3.6525 6 3.1875C6 2.2575 6.7575 1.5 7.6875 1.5H10.3125C10.7775 1.5 11.1975 1.6875 11.505 1.995C11.8125 2.3025 12 2.7225 12 3.1875Z" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 9.75H9" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 12.75H12" stroke="#032432" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <div className='tracking-[-0.04em]'>{katalog_ng?.pagetitle}</div>
              </div>
            </div>
            {hone ?
              <h1 className='font-medium mt-[20px] xl:mt-[40px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start px-[25px] xl:px-0'>{Parser(katalog_ng?.longtitle)}</h1>
            :
              <h2 className='font-medium mt-[20px] xl:mt-[40px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start px-[25px] xl:px-0'>{Parser(katalog_ng?.longtitle)}</h2>
            }
            <div className='grid grid-cols-2 xl:grid-cols-5 gap-[19px] mt-[20px] overflow-hidden'>
              {(katalog_ng?.katalog || []).map((elm, k) => (
                <TAOS
                  as="a"
                  href={elm?.url}
                  key={k}
                  className="
                    group 
                    duration-[300ms] taos:[transform:perspective(2500px)_rotateY(-100deg)] taos:invisible taos:[backface-visibility:hidden]
                  "
                  offset="300"
                >
                  <div className='flex items-center justify-center overflow-hidden bg-[#F5F2F4] rounded-[15px] w-full h-[211px] xl:h-[271px] relative'>
                    <div className="absolute top-[20px] right-[20px] w-[30px] h-[30px] xl:w-[35px] xl:h-[35px] rounded-full bg-white flex items-center justify-center text-black text-[16px] xl:text-[18px] leading-none transition-all duration-300 cursor-pointer group-hover:bg-[#009EE3] group-hover:text-white">
                      <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.25209 4.35598C9.40809 3.99598 9.57009 3.67798 9.73809 3.40198C9.90609 3.11398 10.0741 2.86798 10.2421 2.66398H9.39667e-05V1.69198H10.2421C10.0741 1.47598 9.90609 1.22998 9.73809 0.953984C9.57009 0.665984 9.40809 0.347984 9.25209 -1.61529e-05H10.0981C10.8541 0.875984 11.6521 1.52398 12.4921 1.94398V2.41198C11.6521 2.81998 10.8541 3.46798 10.0981 4.35598H9.25209Z" fill="currentColor"/>
                      </svg>
                    </div>
                    <img className='w-auto h-[144px] xl:h-[271px]' src={elm?.image} alt={elm?.pagetitle} width={137} height={192} />
                  </div>
                  <div className='mt-[14px] text-[16px] xl:text-[18px] tracking-[-0.04em] text-[#032432] leading-none'>
                    {Parser(elm?.longtitle)}
                  </div>
                </TAOS>
              ))}
              <TAOS
                as="div"
                className={`
                  col-span-4 bg-center bg-cover p-[30px] tracking-[-0.04em] rounded-[15px]
                  duration-[300ms] taos:[transform:perspective(2500px)_rotateX(-100deg)] taos:invisible taos:[backface-visibility:hidden]
                  hidden xl:block
                `}
                style={{
                  backgroundImage: `url('${katalog_ng?.block_image}')`
                }}
                offset="300"
              >
                <h3 className='font-medium text-white text-[36px] leading-none'>{Parser(katalog_ng?.block_title)}</h3>
                <div className='mt-[15px] text-white/70 leading-none text-[14px] 2xl:text-[16px] tracking-[-0.02em]'>{Parser(katalog_ng?.block_text)}</div>
                <div className='flex items-end justify-between gap-[17px] mt-[17px]'>
                  <div className='flex-1'>
                    <div className='flex items-center gap-[5px]'>
                      <Social social={data?.social || []} width={40} />
                      <div className='ml-[5px]'>
                        <img src={data?.slogo} width={50} height={50} alt="logo" />
                      </div>
                    </div>
                    {/* Кнопка Оставить заявку с открытием формы */}
                    <div 
                      className='flex w-full items-center justify-center gap-[9px] h-[50px] bg-white rounded-full px-[18px] mt-[9px] cursor-pointer hover:bg-gray-100 transition-colors duration-300'
                      onClick={this.openForm}
                    >
                      <div className='text-black whitespace-nowrap'>Оставить заявку</div>
                      <ArrowIconB />
                    </div>
                  </div>
                  <img src={katalog_ng?.block_image_1} width={340} height={135} className='h-auto' alt="block 1" />
                  <img src={katalog_ng?.block_image_2} width={340} height={135} className='h-auto' alt="block 2" />
                </div>
              </TAOS>
            </div>
          </div>
        </div>

        {/* Форма обратной связи */}
        <OffcanvasForm
          show={showForm}
          hide={this.closeForm}
          formTitle="Оставить заявку"
          productName="" // Можно передать название товара, если нужно
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default App;